import React from 'react';
import { ImageSlot } from './ImageSlot';
import { bonuses, bonusesIntro } from '../data/content';
export function Bonuses() {
  return <section id="bonos" className="bg-parchment-deep text-ink" data-id="element-28" data-mp="pjg7a5ljxg31">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-20" data-id="element-29" data-mp="avv3sakrleul">
        <div className="mx-auto max-w-2xl text-center" data-id="element-30" data-mp="fu69qa7xv57j">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold-deep" data-id="element-31" data-mp="fsliouku24ef">
            {bonusesIntro.eyebrow}
          </p>
          <h2 className="mt-3 font-display text-[1.875rem] font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-32" data-mp="5vqnakjuwk4d">
            {bonusesIntro.title}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-ink-soft" data-id="element-33" data-mp="3o3pum5spe6z1">
            {bonusesIntro.text}
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-34" data-mp="1m9qf188jt3gj">
          {bonuses.map(bonus => <article key={bonus.title} className="flex gap-4 rounded-2xl border border-parchment-line bg-white p-5 sm:gap-6 sm:p-6" data-id="element-35" data-mp="1r9uz188o0gbi">
              <ImageSlot src={bonus.image} alt={`Portada de ${bonus.label}: ${bonus.title}`} label={bonus.label} className="w-24 flex-none self-start sm:w-32" imgClassName="h-auto w-full object-contain drop-shadow-[0_12px_16px_rgba(22,39,63,0.2)]" placeholderClassName="aspect-[3/4] !rounded-lg" data-id="element-36" data-mp="3dfd39lmgs4tx" />

              <div className="flex min-w-0 flex-1 flex-col" data-id="element-37" data-mp="2ugqz1xvnhxls">
                <span className="w-fit rounded-full bg-leaf px-2.5 py-1 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.12em] text-white" data-id="element-38" data-mp="2uibudppshkkp">
                  {bonus.label}
                </span>
                <h3 className="mt-2.5 font-display text-lg font-semibold leading-snug text-ink sm:text-xl" data-id="element-39" data-mp="33ja14frm466z">
                  {bonus.title}
                </h3>
                <p className="mt-2 font-sans text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-40" data-mp="ipwup950y827">
                  {bonus.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}